<div class="d-flex flex-column overflow-hidden min-vh-100 vh-100">
  <main role="main" class="flex-grow-1 overflow-auto main">
    <div id="fh-100">
      <div id="container" class="container">
        <div id="row" class="row">
          <div class="col-lg-12 kaz">
            <img (click)="openKazMap()" width="100%" src="../../assets/img/main/{{imgLang + '1.png'}}" alt="kaz">
            <button translate (click)="openKazMap()" type="button" class="btn btn-warning">main.map_button</button>
          </div>
          <div class="col-lg-12 world">
            <img (click)="openWorldMap()" width="100%" src="../../assets/img/main/{{imgLang + '2.png'}}" alt="world">
            <button translate (click)="openWorldMap()" type="button" class="btn btn-warning">main.map_button</button>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
